/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Pain_RemoveInputs */

const en_us2_profile_editors_pain_remove = /** @type {(inputs: Profile_Editors_Pain_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It doesn't hurt anymore, remove`)
};

const pt_br2_profile_editors_pain_remove = /** @type {(inputs: Profile_Editors_Pain_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não dói mais, remover`)
};

const es_419_profile_editors_pain_remove = /** @type {(inputs: Profile_Editors_Pain_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ya no duele, quitar`)
};

const pt_pt2_profile_editors_pain_remove = /** @type {(inputs: Profile_Editors_Pain_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Já não dói, remover`)
};

const fr_fr2_profile_editors_pain_remove = /** @type {(inputs: Profile_Editors_Pain_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus de douleur, retirer`)
};

const de_de2_profile_editors_pain_remove = /** @type {(inputs: Profile_Editors_Pain_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tut nicht mehr weh, entfernen`)
};

const it_it2_profile_editors_pain_remove = /** @type {(inputs: Profile_Editors_Pain_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non fa più male, rimuovi`)
};

/**
* | output |
* | --- |
* | "It doesn't hurt anymore, remove" |
*
* @param {Profile_Editors_Pain_RemoveInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_pain_remove = /** @type {((inputs?: Profile_Editors_Pain_RemoveInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Pain_RemoveInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_pain_remove(inputs)
	if (locale === "es-419") return es_419_profile_editors_pain_remove(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_pain_remove(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_pain_remove(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_pain_remove(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_pain_remove(inputs)
	return en_us2_profile_editors_pain_remove(inputs)
});
export { profile_editors_pain_remove as "profile-editors.pain_remove" }